function checkRAIDCondition(raid_type, qty_disk, parity_raid=0){
    switch(raid_type){
      case "RAID 0":
        // Minimum 2 disks are required;
        return qty_disk >= 2;
      case "RAID 1":
        // Minimum 2 disks are required, and number of disks must be even;
        return (qty_disk >= 2) && (qty_disk % 2 == 0);
      case "RAID 5":
        // Minimum 3 disks are required;
        return qty_disk >= 3;
      case "RAID 6":
        // Minimum 4 disks are required;
        return qty_disk >= 4;
      case "RAID 10":
        // Minimum 4 disks are required, and number of disks must be even;
        return (qty_disk >= 4) && (qty_disk % 2 == 0);
      case "RAID 50":
        // Minimum 6 disks are required, the number of disks must be even, and the total number of disks must be divided equally between RAID 5 sets.
        var parity_groups = parity_raid * 3;
        return (qty_disk >= 6) && (qty_disk % 2 == 0) && (qty_disk % parity_raid == 0) && (qty_disk >= parity_groups);
      case "RAID 60":
        // Minimum 8 disks are required, the number of disks must be even, and the total number of disks must be divided equally between RAID 6 sets. 
        var parity_groups = parity_raid * 4;
        return (qty_disk >= parity_groups) && (qty_disk >= 8) && (qty_disk % 2 == 0) && (qty_disk % parity_raid == 0);
    }
  }
  
  function displayRAIDError(raid){
    let level_error = {
      "RAID 0": "RAID0 offers no redundancy, all disks are utilized for storage, and requires at least two drives to be used.",
      "RAID 1": "RAID1 mirrors your data from one disk to the other disk for redundancy (2 Disks Minimum), number of disks must be even.",
      "RAID 5": "RAID5 uses one disk for Parity and requires at least three drives to be used.",
      "RAID 6": "RAID6 uses two disks for Parity and requires at least four drives to be used.",
      "RAID 10": "RAID 10 will stripe your RAID1 mirrors using half your disks for redundancy and requires at least four drives to be used.",
      "RAID 50": "RAID50 strips two RAID5 arrays providing increased performance and extra redundancy (2 Disk Parity) and requires at least six drives to be used",
      "RAID 60": "RAID60 strips two RAID6 arrays providing increased performance and extra redundancy (4 Disk Parity) and requires at least eight drives to be used.",
    };
    var error = level_error[raid];
    $("#raid-calculator-result").empty();
    $("#raid-calculator-result").addClass("error");
    $("#raid-calculator-result").html("ERROR: "+error);
  
    return;
  }
  
  function calculateRAID(){
    let raid_level = $("#raid-calculator-level-select option:selected").html();
    $("#raid-calculator-result").empty();
    if (raid_level == "RAID 50" || raid_level == "RAID 60"){
      $("#parity-raid-row").removeClass("invisible");
    } else {
      $("#parity-raid-row").addClass("invisible");
    }
  
    if ($("#single-disk-size-input").val() == "" || $("#qty-disk-input").val() == ""){
      return;
    }
  
    if (!$("#parity-raid-row").hasClass("invisible")){
      var parity_raid = $("#parity-raid-input").val();
      console.log(parity_raid);
      if (parity_raid == ""){
        return;
      }
    }
  
    let single_disk_size = $("#single-disk-size-input").val();
    let qty_disk = $("#qty-disk-input").val();
    let unit = $("#size-unit-select option:selected").html();
    if (unit == "TB") {
      single_disk_size *= 1000;
    }
  
    let kilo_disclaimer = "<sup>*</sup> Usable storage is the actual post-format amount where kilo = 1024 (2<sup>10</sup>) bytes, not 1000.";
    var raw_storage = single_disk_size * qty_disk;
  
    switch(raid_level){
      case "RAID 0":
        if (checkRAIDCondition("RAID 0", qty_disk)){
          var usable_storage = raw_storage;
          var speed_gain = String(qty_disk)+"x read/write speed gain.";
          var fault_tolerance = "None.";
        } else {
          displayRAIDError("RAID 0");
          return;
        }
        break;
      case "RAID 1":
        if (checkRAIDCondition("RAID 1", qty_disk)){
          var usable_storage = raw_storage/2;
          var speed_gain = String(qty_disk)+"x read speed gain.";
          var fault_tolerance = String(qty_disk-1)+" drive failure.";
        } else {
          displayRAIDError("RAID 1");
          return;
        }
        break;
      case "RAID 5":
        if (checkRAIDCondition("RAID 5", qty_disk)){
          var usable_storage = single_disk_size * (qty_disk-1);
          var speed_gain = String(qty_disk-1)+"x read speed gain.";
          var fault_tolerance = "1 drive failure.";
        } else {
          displayRAIDError("RAID 5");
          return;
        }
        break;
      case "RAID 6":
        if (checkRAIDCondition("RAID 6", qty_disk)){
          var usable_storage = single_disk_size * (qty_disk-2);
          var speed_gain = String(qty_disk-2)+"x read speed gain.";
          var fault_tolerance = "2 drive failure.";
        } else {
          displayRAIDError("RAID 6");
          return;
        }
        break;
      case "RAID 10":
        if (checkRAIDCondition("RAID 10", qty_disk)){
          var usable_storage = raw_storage/2;
          var speed_gain = String(qty_disk)+"x read and "+String(qty_disk/2)+"x write speed gain";
          var fault_tolerance = "1 per array.";
        } else {
          displayRAIDError("RAID 10");
          return;
        }
        break;
      case "RAID 50":
        if (checkRAIDCondition("RAID 50", qty_disk, parity_raid)){
          var usable_storage = single_disk_size * (qty_disk-2);
          var speed_gain = String(qty_disk-parity_raid)+"x read speed gain.";
          var fault_tolerance = "1 per array.";
        } else {
          displayRAIDError("RAID 50");
          return;
        }
        break;
      case "RAID 60":
        if (checkRAIDCondition("RAID 60", qty_disk, parity_raid)){
          var usable_storage = single_disk_size * (qty_disk-4);
          var speed_gain = String(qty_disk - (parity_raid * 2))+"x read speed gain.";
          var fault_tolerance = "2 per array.";
        } else {
          displayRAIDError("RAID 60");
          return;
        }
        break;
    } 
  
  
    var usable_storage_gb = String((Math.floor(usable_storage * 0.9313 * 100)) / 100)+"GB";
    var usable_storage_tb = String((Math.floor((usable_storage * 0.9095) / 10)) / 100)+"TB";
  
    if (raw_storage > 999)
      raw_storage = String((raw_storage / 1000).toFixed(2))+"TB";
    else
      raw_storage = String(raw_storage)+"GB";
   
    
    $("#raid-calculator-result").removeClass("error");
    $("#raid-calculator-result").append("<p><strong>Raw Storage: </strong>"+raw_storage+"<p>");
    $("#raid-calculator-result").append("<p><strong><sup>*</sup>Usable Storage: </strong>"+usable_storage_gb+"/"+usable_storage_tb+"<p>");
    $("#raid-calculator-result").append("<p><strong>Speed Gain: </strong>"+speed_gain+"<p>");
    $("#raid-calculator-result").append("<p><strong>Fault Tolerance: </strong>"+fault_tolerance+"<p><br>");
    $("#raid-calculator-result").append("<p>"+kilo_disclaimer+"<p>");
    
  }


function toggleRAIDCalculator(){
  $("#raid-calculator-anchor").toggleClass("invisible");
}